import { useRequest } from 'hooks/useRequest'
import { useTranslation } from 'react-i18next'
import TournamentService from 'services/TournamentService'
import { useProfileTier } from 'state/profile/hooks'
import styled from 'styled-components'
import Button from 'UIKit/Button'
import Text from 'UIKit/Text'
import { revalidateHunnyLevel } from 'utils'

type ActionButtonProps = {
  minEligibleVIPLevel: number
  maxEligibleVIPLevel: number
  tournamentId: string
  isJoined: boolean
  updateJoinTournament: (id: string) => void
  isExpired: boolean
}

export const InvalidAction = ({ content }: { content: string }) => {
  return (
    <StyledInvalidButton mt="12px" height="40px">
      <Text fontSize="14px" fontWeight={700} letterSpacing="-0.28px">
        {content}
      </Text>
    </StyledInvalidButton>
  )
}

const ActionButton: React.FC<ActionButtonProps> = ({
  minEligibleVIPLevel,
  maxEligibleVIPLevel,
  tournamentId,
  isJoined,
  updateJoinTournament,
  isExpired,
}) => {
  const { execute } = useRequest()

  const userTier = useProfileTier()
  const myTierLevel = revalidateHunnyLevel(userTier?.level || 0)
  const isQualifiedLevel = myTierLevel >= minEligibleVIPLevel && myTierLevel <= maxEligibleVIPLevel
  const { t } = useTranslation()

  const buttonContent =
    isJoined && !isExpired
      ? t('Joined')
      : isExpired
      ? t('Finished')
      : isQualifiedLevel
      ? t('Join Tournament')
      : t('Available at VIP {{minEligibleVIPLevel}}-{{maxEligibleVIPLevel}}', {
          minEligibleVIPLevel,
          maxEligibleVIPLevel,
        })

  const isDisableJoinBtn = isJoined || isExpired || !isQualifiedLevel

  const handleJoin = async () => {
    const result = await execute(TournamentService.joinTournament(tournamentId))
    if (result.code === 'success') updateJoinTournament(tournamentId)
  }

  if (isDisableJoinBtn)
    return (
      <StyledInvalidButton mt="12px" height="40px">
        <Text fontSize="14px" fontWeight={600} letterSpacing="-0.28px">
          {buttonContent}
        </Text>
      </StyledInvalidButton>
    )

  return (
    <StyledButton mt="12px" height="40px" onClick={handleJoin}>
      <Text fontSize="14px" fontWeight={600} letterSpacing="-0.28px">
        {buttonContent}
      </Text>
    </StyledButton>
  )
}

const StyledButton = styled(Button).attrs({ variant: 'primary' })`
  border-radius: 8px;
  width: 100%;
  &:hover {
    transition: none !important;
    transform: none !important;
  }
`

export const StyledInvalidButton = styled(StyledButton).attrs({ disabled: true })`
  background: ${({ theme }) => theme.colors.buttonBackgroundAlt3} !important;
  div {
    color: rgba(173, 173, 173, 0.5);
  }
`

export default ActionButton
